// extracted by mini-css-extract-plugin
export var productImage = "_zy-0";